import { DataBean } from "../../DataBean";


export class BudgetActivity extends DataBean {

    public async getBudgetActivityCatalog(regexStr: any, page: any, recordsPerPage: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getBudgetActivityCatalog_String_Number_Number", [regexStr, page, recordsPerPage]);
    }
}